var map = {
	"./arrow.svg": 17434,
	"./copy.svg": 33062,
	"./empty.svg": 79204,
	"./fail.svg": 67330,
	"./logo.svg": 10948,
	"./search.svg": 45031,
	"./success.svg": 34782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40240;